import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list.vue'),
  },
   {
    path: '/service',
    name: 'service',
    component: () => import('../views/service.vue'),
  },
  {
    path: '/service-pc',
    name: 'service-pc',
    component: () => import('../views/service-pc.vue'),
  },
  {
    path: '/list-pc',
    name: 'list-pc',
    component: () => import('../views/list-pc.vue'),
  },
  {
    path:'/',
    redirect: '/list'
  }
]

const router = new VueRouter({
  routes,
})

router.afterEach((to) => {
  if (to.path === '/service') {
    document.title = '外籍用户服务专区'
  } else {
    document.title = 'Service Outlet Inquiry'
  }
})

export default router